import './show-alert.scss';
import templateUrl from './show-alert.html';

/**
 * Inject showAlert and showAlert({
 *    title: '',
 *    ok: '',
 *    text: '', or:
 *    template: '', or:
 *    templateUrl: '',
 * });
 *
 * @example showToast('Fou du fa fa', 'error', 2000);
 */
export default /* @ngInject */ function showAlert($mdDialog) {
    return function(options) {
        let instance = $mdDialog.show({
            controller: function() {
                angular.extend(this, options);
                this.hide = $mdDialog.hide.bind($mdDialog, instance);
            },
            templateUrl: templateUrl,
            controllerAs: 'dialog',
            clickOutsideToClose: true
        });
        return instance;
    };
}



// WEBPACK FOOTER //
// ./forms/services/show-alert.js